(function(){
  function initHero(rootId){
    console.log('YYH Hero initialized:', rootId);
    // 若后续此区块需要添加打字机特效或动画，可在这里编写逻辑
  }

  document.addEventListener('DOMContentLoaded', function(){
    var sections = document.querySelectorAll('[id^="yyh-hero-"]');
    sections.forEach(function(s){ initHero(s.id); });
  });

  window.YYHHero = window.YYHHero || {};
  window.YYHHero.init = initHero;
})();